export const localStorageItems = {
    customerNo: localStorage.getItem("customerNo"),
    userId: localStorage.getItem("userId"),
    apiToken: localStorage.getItem("apiToken"),
    customerLogo: localStorage.getItem("customerLogo"),
    customerName: localStorage.getItem("customerName"),
    customerCompanyName: localStorage.getItem("customerCompanyName"),
    //Note : Add new localstorage items here..
}

export const toastMessages = {
    INVALID_FILE: "Invalid File.",
    INVALID_FILE_FORMAT: "Invalid File Format.",
    NO_RECORDS_FOUND: "No Records Found."
}

export const SACCodeMessages = {
    SAC_CODE_MIN: "Must be greater than or equal to 4.",
    SAC_CODE_MAX: "Must be less than or equal to 8."
}

export const HSNCodeMessages = {
    HSN_CODE_MIN: "Must be greater than or equal to 2.",
    HSN_CODE_MAX: "Must be less than or equal to 6."
}

export const messages = {
    LOADING: "Loading...",
    NO_RECORDS_FOUND: "No Record(s) Found"
}

export const validationMessages = {
    START_DATE_REQUIRED: 'Start Date Required',
    END_DATE_REQUIRED: 'End Date Required'
}

export const dateFormats = {
    dd_MM_yyyy: "dd-MM-yyyy",
    DD_MM_YYYY: "DD-MM-YYYY",
    DDMMYYYY_HHmm: 'DD-MM-YYYY | HH:mm'
}

export const salesOrderPaginationConfig = [
    { pageSize: 8, label: '8' },
    { pageSize: 20, label: '20' },
    { pageSize: 30, label: '30' },
    { pageSize: 50, label: '50' },
]

export const salesOrderConst = {
    SALES_ORDER: 'Sales Order',
    SEARCH_SALES_ORDER: "Search Sales Order No..."
}